import gql from 'graphql-tag';

export const saleGetAddresses = gql`
  query saleGetAddresses($supplierId: Int!, $active: Boolean) {
    saleGetAddresses(supplierId: $supplierId, active: $active) {
      id
      customer_id
      floor_number
      street_number
      road
      building
      unit
      stall
      city
      state
      postal_code
      latlng
      country_id
      address_type_id
      active
      is_default_billing
      asString1
      asString2
    }
  }
`;

export const saleAddAddress = gql`
  mutation saleAddAddress(
    $supplierId: Int!
    $floorNumber: String
    $streetNumber: String
    $road: String
    $building: String
    $unit: String
    $stall: String
    $city: String
    $state: String
    $postalCode: String!
    $latlng: LatLngInput
    $countryId: Int!
    $addressTypeId: Int!
    $isDefault: Boolean
  ) {
    saleAddAddress(
      supplierId: $supplierId
      floorNumber: $floorNumber
      streetNumber: $streetNumber
      road: $road
      building: $building
      unit: $unit
      stall: $stall
      city: $city
      state: $state
      postalCode: $postalCode
      latlng: $latlng
      countryId: $countryId
      addressTypeId: $addressTypeId
      isDefault: $isDefault
    ) {
      id
      street_number
    }
  }
`;

export const saleUpdateAddress = gql`
  mutation saleUpdateAddress($payload: AddressCustomType, $addressId: Int!) {
    saleUpdateAddress(payload: $payload, addressId: $addressId) {
      id
      customer_id
      floor_number
      street_number
      road
      building
      unit
      stall
      city
      state
      postal_code
      latlng
      country_id
      address_type_id
      active
      is_default_billing
    }
  }
`;

export const removeAddress = gql`
  mutation removeAddress($addressId: Int!) {
    removeAddress(address: { id: $addressId })
  }
`;
